import { plainToClass } from 'class-transformer';
import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';

import { CollectApiServiceBase } from './collect-api-base.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ProgressIndicatorService } from './progress-indicator.service';
import { FolderPermissionExpression } from '../models/site-metadata/folder-permission-expression.model';
import { SiteETLRequest } from '../models/site-etl/site-etl-request.model';
import { AsyncJob } from '../models/async-job.model';

export class SiteDataMartData {
    //public dataCollectionId: number = -1;

    public extractFormInstanceHierarchy: boolean = true;
    public extractFormData: boolean = true;
    public maxFormTemplatesToProcess: number = 0;
    public extractGridData: boolean = true;
    public maxGridsToProcess: number = 0;

    /*
    public extractFormInstanceHierarchyFC: FormControl = null;
    public extractFormDataFC: FormControl = null;
    public maxFormTemplatesToProcessFC: FormControl = null;
    public extractGridDataFC: FormControl = null;
    public maxGridsToProcessFC: FormControl = null;
    */

    public constructor(public dataCollectionId) {
        /*
        this.extractFormInstanceHierarchyFC = new FormControl({ value: this.extractFormInstanceHierarchy, disabled: false });
        this.extractFormDataFC = new FormControl({ value: this.extractFormData, disabled: false });
        this.maxFormTemplatesToProcessFC = new FormControl({ value: this.maxFormTemplatesToProcess, disabled: false });
        this.extractGridDataFC = new FormControl({ value: this.extractGridData, disabled: false });
        this.maxGridsToProcessFC = new FormControl({ value: this.maxGridsToProcess, disabled: false });
        */
    }
}

@Injectable({
    providedIn: 'root'
})
export class SiteETLService extends CollectApiServiceBase<SiteETLRequest> {
    public constructor(http: HttpClient, progressIndicatorService: ProgressIndicatorService) {
        super(http, progressIndicatorService, environment.apiUrl, 'siteETL', SiteETLRequest)
    }

    public formatResponse(data: SiteETLRequest): SiteETLRequest {
        let obj = plainToClass(SiteETLRequest, data);
        return (obj);
    }

    // Implement service methods.
    public generateSiteETLJob(dataCollectionId: number, siteDataMartData: SiteDataMartData): Promise<AsyncJob> {
        //let url = `${this.url}/${this.endpoint}/generateSiteETLJob/${dataCollectionId}`;
        let url = `${this.url}/${this.endpoint}/generateSiteETLJob`;

        return this.http.post<AsyncJob>(url, siteDataMartData)
            .toPromise()
            .then(response => {
                //let asyncJob: AsyncJob = response;
                let result = plainToClass(AsyncJob, response);
                return result;

            })
            .catch(this.handleError);
    }

    public runSiteETLJob(dataCollectionId: number): Promise<AsyncJob> {
        let url = `${this.url}/${this.endpoint}/runSiteETLJob/${dataCollectionId}`;

        return this.http.get<any[]>(url)
            .toPromise()
            .then(response => {
                //let asyncJob: AsyncJob = response;
                let result = plainToClass(AsyncJob, response);
                return result;

            })
            .catch(this.handleError);    
    }

    // Method for getting an async job's result URL.
    public getResultFileDownloadUrl(asyncJob: AsyncJob, expectedDownloadFileName: string): string {
        let url = `${this.url}/${this.endpoint}/JobKey/${asyncJob.jobKey}/FileDownloadName/${expectedDownloadFileName}`;

        return (url);
    }

}
